'use client';

import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

function Modal({ isOpen, onClose, children, className = '', id }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!mounted) return null;

  return createPortal(
    isOpen ? (
      <div
        id={id}
        className={`fixed w-screen h-screen top-0 left-0 
          bg-black/[.4] z-[9999] flex items-center justify-center overflow-y-auto ${className}`}
      >
        <div className="z-[41] h-full w-full absolute" onClick={onClose} />
        {children}
      </div>
    ) : null,
    document.body
  );
}

export default Modal;
